import { Button } from "@heroui/react";
import { DeviceType } from "@/types/common";

import { FetchedFolder } from "@/services/api/fetchers/folders";

interface ConfirmDeleteContentProps {
  isBulkDelete: boolean;
  folder?: FetchedFolder | null;
  folderCount?: number;
  noteCount?: number;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  deviceType: DeviceType;
}

export function ConfirmDeleteFolderContent({
  isBulkDelete,
  folder,
  folderCount = 0,
  noteCount = 0,
  onConfirm,
  onOpenChange,
  deviceType,
}: ConfirmDeleteContentProps) {
  // Generate the message
  const getMessage = () => {
    if (isBulkDelete) {
      const parts = [];
      if (folderCount > 0) {
        parts.push(`${folderCount} folder${folderCount > 1 ? "s" : ""}`);
      }
      if (noteCount > 0) {
        parts.push(`${noteCount} note${noteCount > 1 ? "s" : ""}`);
      }
      return `Are you sure you want to delete ${parts.join(" and ")}?`;
    }
    return `Are you sure you want to delete the folder "${folder?.name}"?`;
  };

  return (
    <div>
      <p>{getMessage()}</p>
      {deviceType === "mobile" && (
        <div className="flex gap-2 pt-4">
          <Button variant="flat" fullWidth onPress={() => onOpenChange(false)}>
            Cancel
          </Button>

          <Button color="primary" fullWidth onPress={onConfirm}>
            Delete
          </Button>
        </div>
      )}
    </div>
  );
}
